import { CloseRounded } from "@mui/icons-material";
import { Divider, Grid, IconButton } from "@mui/material";
import React from "react";
import { Form } from "../../../../layout";
import { Model, UseForm } from "../../../../hooks";
import { Button, Input, InputDate, InputTime } from "../../../../controls";

const EditSale = ({ setShowForm }) => {
  const { EditSaleMdl } = Model();
  const { values, errors, setErrors, handleInpChg, handleInpDate } =
    UseForm(EditSaleMdl);

  const validateForm = () => {
    let temp = {};
    temp.name = values.name !== "" ? "" : "Name is required.";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
    }
  };

  const handleClose = () => {
    setShowForm((show) => !show);
  };

  return (
    <Form noValidate>
      <div className="">
        {/* Header  */}
        <div className="p-[10px] pb-[5px] flex items-center  justify-between">
          <div>
            <span className="text-[18px] border-left text-gray-500 font-medium">
              Edit sale on receipt 6
            </span>
          </div>
          <div>
            <IconButton size="small">
              <CloseRounded />
            </IconButton>
          </div>
        </div>
        <Divider />
        <div className="p-[10px] mt-[10px]">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div className="mb-[10px]">
                <span className="text-gray-500">
                  Any changes made on this sale will automatically update your
                  sales and payments reports.
                </span>
              </div>
            </Grid>
            <Grid item xs={6}>
              <InputDate
                label="Date"
                name="date"
                value={values.date}
                error={errors.date}
                onChange={(date) =>
                  handleInpDate("date", new Date(date).toLocaleDateString())
                }
              />
            </Grid>
            <Grid item xs={6}>
              <InputTime
                label="Time"
                name="time"
                value={values.time}
                onChange={(date) =>
                  handleInpDate("time", new Date(date).toLocaleDateString())
                }
              />
            </Grid>
            <Grid item xs={12}>
              <Input
                label="Note"
                name="note"
                value={values.note}
                multiline
                rows={3}
                onChange={handleInpChg}
              />
            </Grid>
            <Grid item xs={12}>
              <div className="flex justify-end items-center gap-3">
                <Button
                  onClick={handleClose}
                  variant="text"
                  size="large"
                  className="!min-w-[90px]"
                >
                  Close
                </Button>
                <Button onClick={handleSubmit} size="large">
                  Submit
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </Form>
  );
};

export default EditSale;
